import React from "react";
import EditContainer from "../EditContainer";
import { PAGES } from "../../../util/constants/pages";

export const AWSApprovalEditContainer = () => (
  <EditContainer page={PAGES.AWS_APPROVAL} />
);
